<template>
    <section class="panel-body">
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <button type="button" @click="save" :disabled="loading" class="btn float-right btn-success">
                    <i class="fa fa-check"></i> {{$t('words.save')}} <i v-show="loading"
                        class="fa fa-circle-o-notch fa-spin"></i></button>
                <router-link to="/usuarios" class="btn btn-default">
                    <i class="fa fa-times"></i> {{$t('words.cancel')}}</router-link>
                <br>
                <br>
                <div class="card card-outline card-outline-tabs" :class="appLayout.card">
                    <div class="card-header p-0 border-bottom-0">
                        <div class="nav-tabs-custom" role="tabpanel">
                            <!-- Nav tabs -->
                            <ul class="nav nav-tabs" role="tablist">
                                <li role="presentation" class="nav-item">
                                    <a class="nav-link active"><i class="fa fa-user"></i>
                                        {{ $t('words.basic_data')}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- Tab panes -->
                    <div class="card-body">
                        <!-- INICIO TAB PESSOAL -->
                        <div class="tab-pane active" id="tabPersonal">
                            <div class="form-group">
                                <span v-html="$t('validation.field_required')"></span>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="form-group">
                                        <required /> <label>Nome Completo</label>
                                        <input name="Nome" :class="{ 'is-invalid': errors.has('Nome')}"
                                            v-validate="{required: true}" v-model="usuario.nome"
                                            placeholder="Insira o nome completo" class="form-control">
                                        <div class="invalid-feedback help-block error">{{errors.first('Nome')}}</div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>CPF</label>
                                        <input name="Documento" :class="{ 'is-invalid': errors.has('Documento')}"
                                            v-validate="{required: false,  document:true}" v-mask="'###.###.###-##'"
                                            v-model="usuario.documento" placeholder="Insira o documento"
                                            class="form-control">
                                        <div class="invalid-feedback help-block error">{{errors.first('Documento')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group" :class="{ 'is-invalid': errors.has('Email')}">
                                        <required /> <label>E-mail</label>
                                        <input :disabled="allowEdit && auth_user.ambiente != 'A'" name="Email"
                                            v-validate="{required: true, email: true}" v-model="usuario.email"
                                            placeholder="Insira o e-mail" type="email" class="form-control">
                                        <div class="invalid-feedback help-block error">{{errors.first('Email')}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>DDD + Número</label>
                                        <input name="Telefone" :class="{ 'is-invalid': errors.has('Telefone')}"
                                            v-mask="['(##)####-####', '(##)#####-####']" v-validate="{required: false}"
                                            v-model="usuario.telefone" placeholder="Insira o número"
                                            class="form-control">
                                        <div class="invalid-feedback help-block error">{{errors.first('Telefone')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Nascimento</label>
                                        <input name="Nascimento" :class="{ 'is-invalid': errors.has('Nascimento')}"
                                            type="date" v-validate="{required: false}" v-model="usuario.nascimento"
                                            class="form-control">
                                        <div class="invalid-feedback help-block error">{{errors.first('Nascimento')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <required /> <label>Permissão Padrão</label>
                                        <select name="Permissao" v-validate="{required: true}"
                                            :class="{ 'is-invalid': errors.has('Permissao')}"
                                            v-model="usuario.fk_cargo_id" class="form-control">
                                            <option :value="null">{{$t('words.select')}}</option>
                                            <option v-for="(item, i) in cargos" :key="i" :value="item.id">
                                                {{item.cargo_nome}}</option>
                                        </select>
                                        <div class="invalid-feedback help-block error">{{errors.first('Permissao')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <required /><label>Nível</label>
                                        <select name="Nivel" v-validate="{required: true}"
                                            :class="{ 'is-invalid': errors.has('Nivel')}" v-model="usuario.fk_nivel_id"
                                            class="form-control">
                                            <option :value="null">{{$t('words.select')}}</option>
                                            <option v-for="(item, i) in empresaNiveis" :key="i" :value="item.id">
                                                {{item.title}}</option>
                                        </select>
                                        <div class="invalid-feedback help-block error">{{errors.first('Nivel')}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                isLoadingEmail: false,
                usuario: {
                    nome: null,
                    nascimento: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    fk_cargo_id: null,
                    fk_nivel_id: null,
                },
                empresaNiveis: []
            };
        },
        beforeMount() {
            this.prepareComponent();
            if (this.$route.name === 'userEdit') {
                this.getUser();
            }
            this.empresaNiveis = this.$store.state.user.data.empresaNiveis;
        },
        computed: {
            cargos() {
                return this.$store.state.cargo.select;
            },
            allowEdit() {
                return this.$route.name === 'userEdit';
            },
            funcionarios() {
                return this.$store.state.pessoa.select;
            },
        },
        watch: {
            $route(_data) {
                if (this.allowEdit || this.$route.name === 'userCreate') {
                    this.prepareComponent();
                    if (this.allowEdit) {
                        this.getUser();
                    }
                }
            }
        },
        methods: {
            prepareComponent() {
                this.$store.dispatch('getAllCargos');
            },
            getUser() {
                this.$store
                    .dispatch('getUserEdit', this.$route.params.id)
                    .then(response => {
                        console.log(response)
                        this.usuario = response;
                    });
            },
            checkUserEmail() {
                if (!this.errors.has('user_email') && this.usuario.email !== '') {
                    this.isLoadingEmail = true;
                    this.$store
                        .dispatch('checkUniqueEmail', this.usuario.email)
                        .then(response => {
                            this.isLoadingEmail = false;
                            response ? this.validEmailUser() : this.invalidEmailUser();
                        });
                } else {
                    this.removeUserEmailAlert();
                }
            },
            validEmailUser() {
                this.removeUserEmailAlert();
                this.errors.add({
                    filed: 'user_email_ok',
                    msg: trans('message.email_valid_text')
                });
                this.errors.add({
                    field: 'user_email_label',
                    msg: trans('message.email_valid')
                });
            },
            invalidEmailUser() {
                this.removeUserEmailAlert();
                this.errors.add({
                    field: 'user_email_bad',
                    msg: trans('message.email_invalid_text')
                });
                this.errors.add({
                    field: 'user_email_label',
                    msg: trans('message.email_invalid')
                });
            },
            removeUserEmailAlert() {
                this.errors.remove('user_email_bad');
                this.errors.remove('user_email_ok');
                this.errors.remove('user_email_label');
            },
            save() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.loading = true;
                        this.$route.name !== 'userEdit' ?
                            this.storeUser() :
                            this.updateUser();
                    }
                });
            },
            storeUser() {
                this.$store
                    .dispatch('storeUser', this.usuario)
                    .then(response => {
                        this.loading = false;
                        toastr({
                            icon: response.status,
                            title: response.message
                        });
                        if (response.status === 'success') {
                            this.resetForm();
                        }
                    });
            },
            updateUser() {
                this.$store
                    .dispatch('updateUserById', this.usuario)
                    .then(response => {
                        this.loading = false;
                        XPathEvaluator
                        toastr({
                            icon: response.status,
                            title: response.message
                        });
                        if (response.status === 'success') {
                            this.resetForm();
                            this.$router.push('/usuarios');
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                    });
            },
            resetForm() {
                this.usuario = {
                    nome: null,
                    nascimento: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    fk_cargo_id: null,
                    fk_nivel_id: null,
                }
                this.empresaNiveis = this.$store.state.user.data.empresaNiveis;
                this.removeUserEmailAlert();
                this.$validator.reset();
            }
        }
    };
</script>